<script>
    import _ from 'lodash'
    import FieldError from '../../shared/FieldError.svelte'

    export let item   = {}
    export let errors = {}
</script>

<form class="ui big form">
    <div class="field"
         class:error={errors.name}>
        <label>Nome</label>
        <input  bind:value={item.name}
                type="text"
                autocomplete="false">
        <FieldError style="label" property={errors['name']}/>
    </div>
    <div class="field">
        <label>Descrição</label>
        <textarea rows="3" bind:value={item.description}></textarea>
    </div>
</form>
<style>
    .ui.form {
        margin: 2em 0;
        max-width: 90%;
    }

    .ui.form .field {
        margin: 1em 0;
    }    
</style>
